/** @jsxImportSource @emotion/react */
import { faFlagSwallowtail } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import CheckField from "./CheckField";

// * Use this component ony where full check date is available
// * On layer overview tables... use the copied and coverted flag stored in layer meta
// * With other words use .....LayerFlagField
class CheckFlagField extends CheckField {
    field_type = "check_flag_field";

    backend_table = "check";

    convert_flag_state_color(state: string | null | undefined) {
        if (state === "-") {
            return "light";
        }
        if (state) {
            const output = state.split("flag-").pop();
            return output;
        }
        return "light";
    }

    // Manual flags are displayed with the FontAwesome flag
    display_component(): JSX.Element {
        return <span className={`text-${this.convert_flag_state_color(this.value as string)}`}>
            <FontAwesomeIcon icon={faFlagSwallowtail} />
        </span>;
    }

}

export default CheckFlagField;
